import reduceFulfillments, {
  FULFILLMENTS_INITIAL_STATE,
  FulfillmentsState,
} from 'requests/fulfillments/reduceFulfillments';
import reduceInputs, {INPUTS_INITIAL_STATE, RequestInputsState} from 'requests/inputs/reduceInputs';
import reduceRequestSchemas, {
  REQUEST_SCHEMAS_INITIAL_STATE,
  RequestSchemasState,
} from 'requests/schemas/reduceRequestSchemas';
import combineBenchlingReducers from 'util/combineBenchlingReducers';

export interface RequestsState {
  inputs: RequestInputsState;
  fulfillments: FulfillmentsState;
  schemas: RequestSchemasState;
}

export const REQUESTS_INITIAL_STATE: RequestsState = {
  inputs: INPUTS_INITIAL_STATE,
  fulfillments: FULFILLMENTS_INITIAL_STATE,
  schemas: REQUEST_SCHEMAS_INITIAL_STATE,
};

export default combineBenchlingReducers<RequestsState>({
  inputs: reduceInputs,
  fulfillments: reduceFulfillments,
  schemas: reduceRequestSchemas,
});
